// removed by extract-text-webpack-plugin
module.exports = {"container":"_4F5I-","header":"a8gq-","menu":"_1f6eG"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/desktop-header/desktop-header.scss
// module id = 1625
// module chunks = 0